import wixData from 'wix-data';
const collectionName = 'SonEclairageVideo';
const fieldToFilterByInCollection = 'tags';
 
$w.onReady(function () {
 
    setRepeatedItemsInRepeater();
    loadDataToRepeater();
 
    $w('#filtre2').onChange((event) => {
        const selectedTags = $w('#filtre2').value;
        loadDataToRepeater(selectedTags);
    })
});
 
function loadDataToRepeater(selectedCategories = []) {
 
    let dataQuery = wixData.query(collectionName);
 
    if (selectedCategories.length > 0) {
        dataQuery = dataQuery.hasSome(fieldToFilterByInCollection, selectedCategories);
    }
 
    dataQuery
        .find()
        .then(results => {
            const itemsReadyForRepeater = results.items;
            $w('#repeater2').data = itemsReadyForRepeater;
            const isRepeaterEmpty = itemsReadyForRepeater.length === 0
 
            if (isRepeaterEmpty) {
                $w('#noproduct').show();
            } else {
                $w('#noproduct').hide();
            }
        })
}
 
function setRepeatedItemsInRepeater() {
 
    $w('#repeater2').onItemReady(($item, itemData) => {
        $item('#titre2').text =itemData.detail;
		$item('#details2').text =itemData.nom;
		$item('#decription2').text =itemData.description;
        $item('#image2').src = itemData.image;
        $item('#image2').tooltip = itemData.detail;
        $item('#prix').text = '€' + itemData.location;
    })
}
